import { Component, Element, h, Host } from '@stencil/core'
import { govHost } from '../../helpers/Dom/template'
import { GovHost } from '../../helpers/Dom/template.types'
import { ContainerClass } from './constants'

@Component({
	tag: 'gov-container',
})
export class GovContainer {
	private h: GovHost

	constructor() {
		this.h = govHost(this.host)
	}

	@Element() host: HTMLGovContainerElement

	render() {
		return (
			<Host class={this.h.classes(ContainerClass.root)}>
				<slot />
			</Host>
		)
	}
}
